import Api from './Api';
import Configuracao from '../util/Configuracao';

class TipoMensalidadeApi extends Api {
  async consultarTiposDeMensalidade () {
    try {
      const tiposMensalidadeUrl = Configuracao.getConfiguracao().urlConsultarTiposMensalidade;
      const response = await this.fetch(tiposMensalidadeUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirTipoMensalidade (tipoMensalidade) {
    try {
      const urlIncluirTipoMensalidade = Configuracao.getConfiguracao().urlIncluirTipoMensalidade;
      const response = await this.fetch(urlIncluirTipoMensalidade, 'put', tipoMensalidade);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirTipoMensalidade (codTipoMensalidade) {
    try {
      const urlExcluirTipoMensalidade = Configuracao.getConfiguracao().urlExcluirTipoMensalidade + '/' + codTipoMensalidade;
      const response = await this.fetch(urlExcluirTipoMensalidade, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarTipoMensalidade (tipoMensalidade) {
    try {
      const urlAlterarTipoMensalidade = Configuracao.getConfiguracao().urlAlterarTipoMensalidade;
      const response = await this.fetch(urlAlterarTipoMensalidade, 'put', tipoMensalidade);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}
export default TipoMensalidadeApi;
